import type {
    ActiveDtc,
    EngineOilState,
    EngineOilTableItem,
    EngineOilTableRequest,
    Status,
} from '@/generated/GeneratedApiTypes';

export type EngineOilFleetItem = EngineOilTableItem;

export interface EngineOilFleetRequest extends Omit<EngineOilTableRequest, 'page' | 'size' | 'sort_by' | 'sort_order'> {
    page: number;
    size: number;
    sort_by: EngineOilSortBy;
    sort_order: SortOrder;
}

export type EngineOilSortBy = 'value' | 'name' | 'vin' | 'customer' | 'workshop';

export type SortOrder = 'asc' | 'desc';

export interface EngineOilFleetPage {
    items: EngineOilFleetItem[];
    page: number;
    size: number;
    totalItems: number;
    totalPages: number;
}

export interface EngineOilRow {
    id: string;
    assetId: string;
    vehicleName: string;
    vin: string;
    workshop: string;
    workshopId: string;
    customer: string;
    state: EngineOilState;
    status: Status;
    measurement: number | null;
    timestamp: string | undefined;
    mileage: number | undefined;
    activeDtc: NonNullable<ActiveDtc> | null;
    isReadingNotPossible: boolean;
}

export const ENGINE_OIL_TABLE_SORT_KEY = {
    VEHICLE_NAME: 'name',
    VIN: 'vin',
    WORKSHOP: 'workshop',
    CUSTOMER: 'customer',
    VALUE: 'value',
} as const;
